import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pwa-employees" }
const _hoisted_2 = { class: "emp-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "emp-count" }
const _hoisted_5 = { class: "search-box" }
const _hoisted_6 = { class: "filter-chips" }
const _hoisted_7 = { class: "emp-list" }
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "emp-info" }
const _hoisted_11 = { class: "emp-row" }
const _hoisted_12 = { class: "emp-name" }
const _hoisted_13 = { class: "emp-meta" }
const _hoisted_14 = { class: "job" }
const _hoisted_15 = { class: "tenure" }
const _hoisted_16 = { class: "emp-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "sheet-header" }
const _hoisted_19 = {
  key: 0,
  class: "sheet-content"
}
const _hoisted_20 = { class: "profile-section" }
const _hoisted_21 = { class: "profile-info" }
const _hoisted_22 = { class: "profile-name" }
const _hoisted_23 = { class: "profile-job" }
const _hoisted_24 = {
  key: 0,
  class: "quick-actions"
}
const _hoisted_25 = {
  key: 1,
  class: "wage-section"
}
const _hoisted_26 = { class: "section-title" }
const _hoisted_27 = { class: "wage-card" }
const _hoisted_28 = { class: "wage-main" }
const _hoisted_29 = { class: "wage-value" }
const _hoisted_30 = { class: "wage-details" }
const _hoisted_31 = { class: "wage-row" }
const _hoisted_32 = { class: "wage-row" }
const _hoisted_33 = { class: "deduction" }
const _hoisted_34 = {
  key: 2,
  class: "wage-section empty"
}
const _hoisted_35 = { class: "section-title" }
const _hoisted_36 = { class: "info-section" }
const _hoisted_37 = { class: "section-title" }
const _hoisted_38 = { class: "info-list" }
const _hoisted_39 = {
  key: 0,
  class: "info-item"
}
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 1,
  class: "info-item"
}
const _hoisted_42 = { class: "info-value" }
const _hoisted_43 = {
  key: 2,
  class: "info-item"
}
const _hoisted_44 = { class: "info-value" }
const _hoisted_45 = {
  key: 3,
  class: "info-item"
}
const _hoisted_46 = { class: "info-value" }
const _hoisted_47 = { class: "info-section" }
const _hoisted_48 = { class: "section-title" }
const _hoisted_49 = { class: "info-list" }
const _hoisted_50 = { class: "info-item" }
const _hoisted_51 = { class: "info-value" }
const _hoisted_52 = { class: "info-item" }
const _hoisted_53 = { class: "info-value" }
const _hoisted_54 = {
  key: 0,
  class: "info-item"
}
const _hoisted_55 = { class: "info-value warn" }
const _hoisted_56 = { class: "info-section" }
const _hoisted_57 = { class: "section-title" }
const _hoisted_58 = { class: "account-info" }
const _hoisted_59 = { class: "account-label" }
const _hoisted_60 = {
  key: 0,
  class: "account-id"
}

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

interface Employee {
  emp_idx?: number;
  emp_code: string;
  emp_id?: string;
  m_sisul_code: string;
  emp_name: string;
  emp_birth: string;
  emp_job: string;
  emp_in_date?: string;
  emp_out_date?: string;
  emp_phone?: string;
  emp_email?: string;
  emp_addr?: string;
  emp_status?: 'ACTIVE' | 'INACTIVE' | 'RETIRING';
}

interface WageData {
  yearMonth: string;
  netPay: number;
  totalPay: number;
  totalDeduction: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaEmployees',
  setup(__props) {

const store = useStore();
const router = useRouter();
const user = computed(() => store.state.user);

const isLoading = ref(false);
const isLoadingWage = ref(false);
const employees = ref<Employee[]>([]);
const searchKeyword = ref('');
const currentFilter = ref('all');
const showDetailSheet = ref(false);
const selectedEmployee = ref<Employee | null>(null);
const employeeWageData = ref<WageData | null>(null);

// 요약
const employeeSummary = computed(() => ({
  total: employees.value.length,
  active: employees.value.filter(e => e.emp_status === 'ACTIVE').length
}));

// 필터링
const filteredEmployees = computed(() => {
  let result = employees.value;

  if (searchKeyword.value) {
    const keyword = searchKeyword.value.toLowerCase();
    result = result.filter(emp =>
      emp.emp_name?.toLowerCase().includes(keyword) ||
      emp.emp_phone?.includes(keyword)
    );
  }

  switch (currentFilter.value) {
    case 'active':
      result = result.filter(e => e.emp_status === 'ACTIVE');
      break;
    case 'yobo':
      result = result.filter(e => e.emp_job === '요양보호사');
      break;
    case 'sabok':
      result = result.filter(e => e.emp_job === '사회복지사');
      break;
  }

  return result;
});

// 조회
const fetchEmployees = async () => {
  if (!user.value?.m_sisul_code) return;

  try {
    isLoading.value = true;
    const response = await axios.get(`/api/emp/facility/${user.value.m_sisul_code}`, {
      withCredentials: true
    });

    if (response.data.success) {
      employees.value = response.data.data || [];
    }
  } catch (error) {
    console.error('직원 조회 오류:', error);
    store.commit('showSnackbar', { text: '직원 정보를 불러오지 못했어요.', color: 'error' });
  } finally {
    isLoading.value = false;
  }
};

// 직원 급여 조회
const fetchEmployeeWage = async (employee: Employee) => {
  if (!user.value?.m_sisul_code || !employee.emp_name) {
    employeeWageData.value = null;
    return;
  }

  try {
    isLoadingWage.value = true;
    
    // 지난달 기준으로 조회
    const now = new Date();
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const ym = `${lastMonth.getFullYear()}${String(lastMonth.getMonth() + 1).padStart(2, '0')}`;
    
    const response = await axios.get(`/api/calc/payroll/${user.value.m_sisul_code}/${ym}`, {
      withCredentials: true
    });

    if (response.data.success && response.data.data) {
      // 해당 직원 찾기
      const empData = response.data.data.find((item: any) => 
        item.emp_name === employee.emp_name
      );
      
      if (empData) {
        employeeWageData.value = {
          yearMonth: `${lastMonth.getFullYear()}년 ${lastMonth.getMonth() + 1}월`,
          netPay: empData.netPay || empData.실지급액 || 0,
          totalPay: empData.totalPay || empData.지급액합계 || 0,
          totalDeduction: empData.totalDeduction || empData.공제액합계 || 0
        };
      } else {
        employeeWageData.value = null;
      }
    } else {
      employeeWageData.value = null;
    }
  } catch (error) {
    console.error('급여 조회 오류:', error);
    employeeWageData.value = null;
  } finally {
    isLoadingWage.value = false;
  }
};

// 유틸
const setFilter = (filter: string) => {
  currentFilter.value = filter;
};

const getStatusText = (status?: string) => {
  switch (status) {
    case 'ACTIVE': return '재직';
    case 'INACTIVE': return '퇴사';
    case 'RETIRING': return '퇴사예정';
    default: return '재직';
  }
};

const getJobColor = (job: string) => {
  if (job === '요양보호사') return 'yobo';
  if (job === '사회복지사') return 'sabok';
  if (job === '센터장') return 'sisul';
  return 'default';
};

const getTenure = (inDate?: string) => {
  if (!inDate) return '-';
  const start = new Date(inDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
  const now = new Date();
  const years = now.getFullYear() - start.getFullYear();
  const months = now.getMonth() - start.getMonth();
  const totalMonths = years * 12 + months;
  
  if (totalMonths < 1) return '1개월 미만';
  if (totalMonths < 12) return `${totalMonths}개월`;
  const y = Math.floor(totalMonths / 12);
  const m = totalMonths % 12;
  return m > 0 ? `${y}년 ${m}개월` : `${y}년`;
};

const formatBirth = (birth: string) => {
  if (!birth || birth.length !== 8) return birth;
  return `${birth.substring(0, 4)}.${birth.substring(4, 6)}.${birth.substring(6, 8)}`;
};

const formatCurrency = (value: number) => {
  return value.toLocaleString();
};

// 액션
const openEmployeeDetail = async (employee: Employee) => {
  selectedEmployee.value = employee;
  employeeWageData.value = null;
  showDetailSheet.value = true;
  
  // 급여 정보 조회
  await fetchEmployeeWage(employee);
};

const callEmployee = (employee: Employee) => {
  if (employee.emp_phone) {
    window.location.href = `tel:${employee.emp_phone}`;
  }
};

const sendSms = (employee: Employee) => {
  if (employee.emp_phone) {
    window.location.href = `sms:${employee.emp_phone}`;
  }
};

const goToPayroll = () => {
  showDetailSheet.value = false;
  router.push('/pwa/payroll');
};

onMounted(() => {
  fetchEmployees();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "page-title" }, "직원", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(employeeSummary.value.active) + "/" + _toDisplayString(employeeSummary.value.total) + "명", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#9ca3af"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("mdi-magnify", -1)
          ]))]),
          _: 1
        }),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
          type: "text",
          placeholder: "이름, 연락처 검색"
        }, null, 512), [
          [_vModelText, searchKeyword.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: currentFilter.value === 'all' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setFilter('all')))
      }, "전체", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: currentFilter.value === 'active' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (setFilter('active')))
      }, "재직", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: currentFilter.value === 'yobo' }),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (setFilter('yobo')))
      }, "요양보호사", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: currentFilter.value === 'sabok' }),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (setFilter('sabok')))
      }, "사회복지사", 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "emp-item skeleton"
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "skeleton-avatar" }, null, -1),
              _createElementVNode("div", { class: "skeleton-content" }, [
                _createElementVNode("div", { class: "skeleton-text" }),
                _createElementVNode("div", { class: "skeleton-text short" })
              ], -1)
            ]))])
          }), 64))
        : (filteredEmployees.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#d1d5db"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-account-search", -1)
                ]))]),
                _: 1
              }),
              _cache[13] || (_cache[13] = _createElementVNode("span", null, "검색 결과가 없습니다", -1))
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredEmployees.value, (employee) => {
              return (_openBlock(), _createElementBlock("div", {
                key: employee.emp_idx,
                class: "emp-item",
                onClick: ($event: any) => (openEmployeeDetail(employee))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["emp-avatar", getJobColor(employee.emp_job)])
                }, _toDisplayString(employee.emp_name?.charAt(0)), 3),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(employee.emp_name), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["emp-status", employee.emp_status])
                    }, _toDisplayString(getStatusText(employee.emp_status)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(employee.emp_job), 1),
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "divider" }, "·", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(getTenure(employee.emp_in_date)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (employee.emp_phone)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "action-btn call",
                        onClick: _withModifiers(($event: any) => (callEmployee(employee)), ["stop"])
                      }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("mdi-phone", -1)
                          ]))]),
                          _: 1
                        })
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#ccc"
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 8, _hoisted_9))
            }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showDetailSheet.value }]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (showDetailSheet.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet", { open: showDetailSheet.value }])
    }, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_18, [
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "sheet-title" }, "직원 정보", -1)),
        _createElementVNode("button", {
          class: "sheet-close",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showDetailSheet.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (selectedEmployee.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(["profile-avatar", getJobColor(selectedEmployee.value.emp_job)])
              }, _toDisplayString(selectedEmployee.value.emp_name?.charAt(0)), 3),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h2", _hoisted_22, _toDisplayString(selectedEmployee.value.emp_name), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(selectedEmployee.value.emp_job), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["profile-status", selectedEmployee.value.emp_status])
                }, _toDisplayString(getStatusText(selectedEmployee.value.emp_status)), 3)
              ])
            ]),
            (selectedEmployee.value.emp_phone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "qa-btn",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (callEmployee(selectedEmployee.value)))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#1e3a8a"
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("mdi-phone", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "전화", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "qa-btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (sendSms(selectedEmployee.value)))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#1e3a8a"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-message-text", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[22] || (_cache[22] = _createElementVNode("span", null, "문자", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (employeeWageData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#1e3a8a"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-cash", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, "최근 급여 (" + _toDisplayString(employeeWageData.value.yearMonth) + ")", 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "wage-label" }, "실지급액", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(formatCurrency(employeeWageData.value.netPay)) + "원", 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", null, "지급액 합계", -1)),
                        _createElementVNode("span", null, _toDisplayString(formatCurrency(employeeWageData.value.totalPay)) + "원", 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", null, "공제액 합계", -1)),
                        _createElementVNode("span", _hoisted_33, "-" + _toDisplayString(formatCurrency(employeeWageData.value.totalDeduction)) + "원", 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "wage-more",
                      onClick: goToPayroll
                    }, [
                      _cache[28] || (_cache[28] = _createTextVNode(" 상세 내역 보기 ", -1)),
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : (!isLoadingWage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        color: "#9ca3af"
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("mdi-cash", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[30] || (_cache[30] = _createElementVNode("span", null, "최근 급여", -1))
                    ]),
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "no-data" }, "급여 정보가 없습니다", -1))
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#1e3a8a"
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("mdi-account", -1)
                  ]))]),
                  _: 1
                }),
                _cache[33] || (_cache[33] = _createElementVNode("span", null, "기본 정보", -1))
              ]),
              _createElementVNode("div", _hoisted_38, [
                (selectedEmployee.value.emp_phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "info-label" }, "연락처", -1)),
                      _createElementVNode("a", {
                        href: `tel:${selectedEmployee.value.emp_phone}`,
                        class: "info-value link"
                      }, _toDisplayString(selectedEmployee.value.emp_phone), 9, _hoisted_40)
                    ]))
                  : _createCommentVNode("", true),
                (selectedEmployee.value.emp_birth)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "info-label" }, "생년월일", -1)),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(formatBirth(selectedEmployee.value.emp_birth)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (selectedEmployee.value.emp_email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "info-label" }, "이메일", -1)),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(selectedEmployee.value.emp_email), 1)
                    ]))
                  : _createCommentVNode("", true),
                (selectedEmployee.value.emp_addr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "info-label" }, "주소", -1)),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(selectedEmployee.value.emp_addr), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#1e3a8a"
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-briefcase", -1)
                  ]))]),
                  _: 1
                }),
                _cache[39] || (_cache[39] = _createElementVNode("span", null, "재직 정보", -1))
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "info-label" }, "입사일", -1)),
                  _createElementVNode("span", _hoisted_51, _toDisplayString(selectedEmployee.value.emp_in_date || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _cache[41] || (_cache[41] = _createElementVNode("span", { class: "info-label" }, "근속기간", -1)),
                  _createElementVNode("span", _hoisted_53, _toDisplayString(getTenure(selectedEmployee.value.emp_in_date)), 1)
                ]),
                (selectedEmployee.value.emp_out_date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _cache[42] || (_cache[42] = _createElementVNode("span", { class: "info-label" }, "퇴사일", -1)),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(selectedEmployee.value.emp_out_date), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#1e3a8a"
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode("mdi-account-key", -1)
                  ]))]),
                  _: 1
                }),
                _cache[44] || (_cache[44] = _createElementVNode("span", null, "앱 계정", -1))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["account-status", selectedEmployee.value.emp_id ? 'active' : 'inactive'])
              }, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: selectedEmployee.value.emp_id ? '#10b981' : '#9ca3af'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectedEmployee.value.emp_id ? 'mdi-check-circle' : 'mdi-close-circle'), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(selectedEmployee.value.emp_id ? '계정 등록됨' : '계정 미등록'), 1),
                  (selectedEmployee.value.emp_id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "ID: " + _toDisplayString(selectedEmployee.value.emp_id), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: "직원 정보를 불러오는 중..."
    }, null, 8, ["is-visible"])
  ]))
}
}

})